import React from "react";
import { useTranslation } from "react-i18next";
import FormatResourceStatusLabel from "go-app/components/FormatResourceStatus/FormatResourceStatus";
import { StockAdjustmentStatus } from "../../../../../../../../../services/Api/Organization/types";

interface Props {
	status: StockAdjustmentStatus;
}

const getStockAdjustmentsStatusClassName = (
	status: StockAdjustmentStatus
): "primary" | "success" | "danger" | "warning" | "blue" => {
	switch (status) {
		case "CLOSED":
			return "success";
		case "DRAFT":
			return "warning";
		case "OPEN":
			return "blue";
		case "VOID":
			return "danger";
		default:
			return "primary";
	}
};

export const getStockAdjustmentEntityStatus = (status: StockAdjustmentStatus) => {
	switch (status) {
		case "CLOSED":
			return "ACTIVE";
		case "DRAFT":
			return "WARNING";
		case "VOID":
			return "DISABLED";
		case "OPEN":
			return "INFORMATION";
		default:
			return status;
	}
};

const StockAdjustmentStatusLabel = ({ status }: Props) => {
	const { t } = useTranslation();
	const translation = t(`enums.common.status.${status}`, { ns: ["translation", "lib"] });

	return (
		<FormatResourceStatusLabel
			status={status}
			className={getStockAdjustmentsStatusClassName(status)}
			translation={translation}
		/>
	);
};

export default StockAdjustmentStatusLabel;
